import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrichadmin.admin.querylog');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-nrichadmin-admin-querylog',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichadminAdminQuerylogComponent implements OnInit {
    public logs: any[] = [];
    public loading: boolean = true;
    public page: number = 1;
    public lastpage: number = 1;
    public classification: string = '';
    public selectedLog: any = null;

    public classifications: string[] = ['', 'normal', 'chitchat', 'distortion', 'injection', 'profanity', 'spam', 'out_of_scope'];
    public classLabels: any = {
        '': '전체', 'normal': '정상', 'chitchat': '잡담', 'distortion': '왜곡',
        'injection': '인젝션', 'profanity': '욕설', 'spam': '스팸', 'out_of_scope': '범위 외'
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load(page: number = 1) {
        this.loading = true;
        this.page = page;
        await this.service.render();
        const { code, data } = await wiz.call("query_logs", {
            page: this.page, dump: 20, classification: this.classification
        });
        if (code === 200) {
            this.logs = data.list || [];
            this.lastpage = data.lastpage || 1;
        }
        this.loading = false;
        await this.service.render();
    }

    public async filterByClass(cls: string) {
        this.classification = cls;
        await this.load(1);
    }

    public async showDetail(log: any) {
        const { code, data } = await wiz.call("query_log_detail", { id: log.id });
        if (code === 200) {
            this.selectedLog = data;
        }
        await this.service.render();
    }

    public closeDetail() {
        this.selectedLog = null;
    }

    public classColor(cls: string): string {
        const map: any = {
            'normal': 'bg-green-100 text-green-800',
            'chitchat': 'bg-blue-100 text-blue-800',
            'distortion': 'bg-red-100 text-red-800',
            'injection': 'bg-purple-100 text-purple-800',
            'profanity': 'bg-orange-100 text-orange-800',
            'spam': 'bg-gray-100 text-gray-800',
            'out_of_scope': 'bg-yellow-100 text-yellow-800',
        };
        return map[cls?.toLowerCase()] || 'bg-gray-100 text-gray-800';
    }

    public pages(): number[] {
        const pages: number[] = [];
        const start = Math.max(1, this.page - 2);
        const end = Math.min(this.lastpage, this.page + 2);
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    }
}

export default PortalNrichadminAdminQuerylogComponent;